/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'equals': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(11 11)" _stroke="#00272E"><path pid="0" d="M10 6.667H0"/><path pid="1" d="M10 2.667H0"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/equals.js